import type { RegulatoryBook } from '@/api/regulatory'
import { useQuery } from '@tanstack/react-query'
import { client } from '../lib/api-client'

const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000

// Book-level responsible-gambling statements (sportsbooks.regulatory_full)
// for the widget's "18+ Only" footer disclosure. The data changes only when
// someone edits a book's statement on the /affiliate operator page, so it's
// cached as aggressively as geo/approvals. A failed fetch leaves the strip
// rendered without a caret — the disclosure line itself never depends on
// this request.
export function useRegulatory() {
  return useQuery<{ books: RegulatoryBook[] }>({
    queryKey: ['regulatory'],
    queryFn: async () => {
      const response = await client.api.v1.regulatory.$get()
      if (!response.ok)
        throw new Error('Failed to fetch regulatory statements')
      return response.json() as Promise<{ books: RegulatoryBook[] }>
    },
    staleTime: TWENTY_FOUR_HOURS,
    gcTime: TWENTY_FOUR_HOURS,
    refetchOnWindowFocus: false,
  })
}
